export const useLayoutMethods = ({ layoutVariables }) => {
  const {
    openSaleTransfer,
    openMenuSupport,
    openMenuSales,
    openMenuMarketing,
    openMenuReportsSales,
    openMenuReportsLines,
    openMenuReportsPortability,
    openMenuManager,
    openShipping,
    openMenuAccounting,
    paymentSuppliers,
    setOpenSaleTransfer,
    setOpenMenuSupport,
    setOpenMenuSales,
    setOpenMenuMarketing,
    setOpenMenuReportsSales,
    setOpenMenuReportsLines,
    setOpenMenuReportsPortability,
    setOpenMenuManager,
    setOpenShipping,
    setOpenMenuAccounting,
    setOpen,
    setOpenPaymentSuppliers,
    openMenuVinculation,
    setOpenMenuVinculation,
    openMenuMTCenter,
    setOpenMenuMTCenter,
    openMenuReportsIft,
    setOpenMenuReportsIft,
    openLineAssignments,
    setOpenLineAssignments,
  } = layoutVariables || {};

  const handleOpenSuppliers = () => {
    setOpenPaymentSuppliers(!paymentSuppliers);
  };

  const handleOpenSaleTransfer = () => {
    setOpenSaleTransfer(!openSaleTransfer);
  };

  const handleClickSupport = () => {
    setOpenMenuSupport(!openMenuSupport);
  };

  const handleClickSales = () => {
    setOpenMenuSales(!openMenuSales);
  };

  const handleClickMarketing = () => {
    setOpenMenuMarketing(!openMenuMarketing);
  };

  const handleClickReportsSales = () => {
    setOpenMenuReportsSales(!openMenuReportsSales);
  };

  const handleClickReportsLines = () => {
    setOpenMenuReportsLines(!openMenuReportsLines);
  };

  const handleClickReportsPortability = () => {
    setOpenMenuReportsPortability(!openMenuReportsPortability);
  };

  const handleClickManager = () => {
    setOpenMenuManager(!openMenuManager);
  };

  const handleClickShipping = () => {
    setOpenShipping(!openShipping);
  };

  const handleClickMenuAccounting = () => {
    setOpenMenuAccounting(!openMenuAccounting);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleOpenVinculation = () => {
    setOpenMenuVinculation(!openMenuVinculation);
  };

  const handleOpenMTCenter = () => {
    setOpenMenuMTCenter(!openMenuMTCenter);
  };

  const handleClickReportsIft = () => {
    setOpenMenuReportsIft(!openMenuReportsIft);
  };

  const handleClickLineAssignments = () => {
    setOpenLineAssignments(!openLineAssignments);
  };

  return {
    layoutMethods: {
      handleOpenSaleTransfer,
      handleClickSupport,
      handleClickSales,
      handleClickMarketing,
      handleClickReportsSales,
      handleClickReportsLines,
      handleClickReportsPortability,
      handleClickManager,
      handleClickShipping,
      handleClickMenuAccounting,
      handleDrawerOpen,
      handleDrawerClose,
      handleOpenSuppliers,
      handleOpenVinculation,
      handleOpenMTCenter,
      handleClickReportsIft,
      handleClickLineAssignments,
    },
  };
};
